
import { Component, Input } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';
import { FreyaCommonModule } from 'src/app/freya-common/freya-common.module';
import { CUSTOMER_TYPES, DEFAULT_HOW_HEARD_DROPDOWN_OPTIONS, JOB_CATEGORIES, JOB_CREATE_INDEXES, JOB_ORIGINS } from 'src/app/global.constants';
import { LibModule } from 'src/app/lib.ts/lib.module';


import { SourceTreeSelectComponent } from '../../../shared/source-tree-select/source-tree-select.component';
import { createConfigSelector } from '../../../state/branding.store';
import { JobSearchUsersComponent } from '../../job-activity/job-search-users/job-search-users.component';

import { EMAIL_PATTERN, PHONE_PATTERN } from '../../job-helpers';
import { jobToolFeature, NewOpportunityCard, selectCustomerEditable } from '../../job-tool.reducer';

import { JobLocationComponent } from '../job-location/job-location.component';


import { JobCreateCustomerActions } from './job-create-customer.actions';
import { jobCreateCustomerFeature } from './job-create-customer.feature';


export const selectCustomerConfigs = createSelector(
  createConfigSelector('JOBS_HOWHEARDOPTIONS', DEFAULT_HOW_HEARD_DROPDOWN_OPTIONS),
  createConfigSelector('JOBS_HOWHEARDMANDATORY'),
  createConfigSelector('JOBS_ORIGINS', JOB_ORIGINS),
  createConfigSelector('CUSTOMER_TYPES', CUSTOMER_TYPES),
  (howHeard, mandatory, origins, types) => ({
    howHeard,
    mandatory,
    origins,
    types
  })
);

@Component({
  selector: 'app-job-create-customer',
  standalone: true,
  imports: [
    FreyaCommonModule,
    LibModule,
    JobSearchUsersComponent,
    JobLocationComponent,
    SourceTreeSelectComponent,
  ],
  templateUrl: './job-create-customer.component.html',
  styleUrls: ['./job-create-customer.component.scss']
})
export class JobCreateCustomerComponent {
  @Input() renderHeadless = false;

  public jobCategories: string[] | [] = JOB_CATEGORIES;

  public jobCreateIndexes = JOB_CREATE_INDEXES;

  constructor(
    public store: Store,
  ) { }

  public viewModel$ = this.store.select(createSelector(
    jobCreateCustomerFeature.selectCustomerEditor,
    jobToolFeature.selectMovingDate,
    jobToolFeature.selectCollapsedNewOpportunityCards,
    selectCustomerEditable,
    selectCustomerConfigs,
    (
      customerEditor,
      movingDate,
      collapsedCards,
      customerEditable,
      configs,
    ) => {

      let { howHeard: howHeardDropdownOptions, origins: jobOriginOptions, types: customerTypeOptions } = configs;
      const { mandatory: howHeardMandatory } = configs;

      if (customerEditor.referralSource && !howHeardDropdownOptions.includes(customerEditor.referralSource)) {
        howHeardDropdownOptions = [ ...howHeardDropdownOptions, customerEditor.referralSource ];
      }

      if (customerEditor.customerType && !customerTypeOptions.includes(customerEditor.customerType)) {
        customerTypeOptions = [ ...customerTypeOptions, customerEditor.customerType ];
      }

      if (customerEditor.jobOrigin && !jobOriginOptions.includes(customerEditor.jobOrigin)) {
        jobOriginOptions = [ ...jobOriginOptions, customerEditor.jobOrigin ];
      }

      return {
        ...customerEditor,
        additionalContacts: customerEditor.additionalContacts.filter((c) => !c.isUnlinked),
        movingDate,
        howHeardDropdownOptions,
        howHeardMandatory,
        jobOriginOptions,
        customerTypeOptions,
        isCardCollapsed: NewOpportunityCard.createCustomer in collapsedCards,
        customerEditable,
        emailPattern: EMAIL_PATTERN,
        phonePattern: PHONE_PATTERN,
      }
    }
  ));

  public actions = JobCreateCustomerActions;

  trackByIndex(index: number) {
    return index;
  }
}
